import type { UploadFile } from "antd";

import { useEffect, useState } from "react";

import { DATASET_TYPE, type DatasetImage } from "@/entities/dataset";
import { useDatasetEditMutator } from "@/modules/dataset/dataset-edit-mutator";
import { convertDatasetsImageToUploadFiles } from "@/modules/dataset-image";
import { useDatasetsMutatorSync } from "@/modules/datasets/datasets-mutator";
import { updateFileStatusInFileList } from "@/modules/upload-file";

export const useDatasetImageSectionFiles = (datasets: DatasetImage[]) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const { addMutatorItem } = useDatasetsMutatorSync();
  const { editDataset } = useDatasetEditMutator();

  useEffect(
    () => setFileList(convertDatasetsImageToUploadFiles(datasets)),
    [datasets.length]
  );

  const onFileUploaded = (newFile: UploadFile) => {
    setFileList((fileList) => [newFile, ...fileList]);
  };

  const deleteDataset = (file: UploadFile, dataset: DatasetImage) => {
    addMutatorItem({
      mutationType: "delete",
      datasetType: DATASET_TYPE.IMAGE,
      datasetId: dataset.id,
    });

    setFileList((files) =>
      updateFileStatusInFileList({ file, files, status: "removed" })
    );
  };

  return {
    fileList,
    onFileUploaded,
    editDataset,
    deleteDataset,
  };
};
